import React from 'react'

// Icons
import { ReactComponent as ChevronRight } from '@sketch/icons/chevron-horizontal-12-svg'

// Styles
import { Item, Divider } from './Crumb.styles'

/**
 * Step
 *
 * A single breadcrumb item "1 Crumb >" used in <OrderedBreadcrumbs />
 *
 */
interface CrumbProps {
  isActive: boolean
  showAllInMobile?: boolean
  isLink?: boolean
  isCompleted: boolean
}

const Crumb: React.FC<CrumbProps> = ({
  children,
  isActive,
  showAllInMobile,
  isLink,
  isCompleted,
}) => {
  return (
    <Item
      $isActive={isActive}
      $isCompleted={isCompleted}
      $showAllInMobile={showAllInMobile}
      $isLink={isLink}
    >
      {children}
      <Divider>
        <ChevronRight height="16px" />
      </Divider>
    </Item>
  )
}

export default Crumb
